import { SecondScreenNoteData } from "../Models/SecondScreenNoteData";
import { SecondScreenService } from "./SecondScreenService";

export class SecondScreenNoteService {
    private static secondScreenNoteService: SecondScreenService<SecondScreenNoteData> = null;

    public static getInstance(): SecondScreenService<SecondScreenNoteData> {
        if (!SecondScreenNoteService.secondScreenNoteService)
            SecondScreenNoteService.secondScreenNoteService =
                new SecondScreenService<SecondScreenNoteData>(
                    rootPath + "/2ndScreen",
                    {
                        noteServiceName: "SecondScreenNote",
                        encounterUpdateServiceName: "SecondScreenEncounterUpdate"
                    },
                    () => { }
                );

        return SecondScreenNoteService.secondScreenNoteService;
    }
}
